export const CMS_BRANCH_PREFIX = 'cms';
export const DEFAULT_PR_BODY = 'Automatically generated by Netlify CMS';
export const MERGE_COMMIT_MESSAGE = 'Automatically generated. Merged on Netlify CMS.';
const DEFAULT_NETLIFY_CMS_LABEL_PREFIX = 'netlify-cms/';

function getLabelPrefix(labelPrefix) {
  return labelPrefix || DEFAULT_NETLIFY_CMS_LABEL_PREFIX;
}

export function isCMSLabel(label, labelPrefix) {
  return label.startsWith(getLabelPrefix(labelPrefix));
}
export function labelToStatus(label, labelPrefix) {
  return label.substr(getLabelPrefix(labelPrefix).length);
}
export function statusToLabel(status, labelPrefix) {
  return `${getLabelPrefix(labelPrefix)}${status}`;
}
export function generateContentKey(collectionName, slug) {
  return `${collectionName}/${slug}`;
}
export function parseContentKey(contentKey) {
  const index = contentKey.indexOf('/');
  return {
    collection: contentKey.substr(0, index),
    slug: contentKey.substr(index + 1)
  };
}
export function contentKeyFromBranch(branch) {
  return branch.substring(`${CMS_BRANCH_PREFIX}/`.length);
}
export function branchFromContentKey(contentKey) {
  return `${CMS_BRANCH_PREFIX}/${contentKey}`;
}